/**
 * Parses HTML into a Document
 */
export default class ParsedPage {
  public parse(html: string): Document {
    return new DOMParser().parseFromString(html, 'text/html');
  }
}
